import script from "./Sidenav.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidenav.vue?vue&type=script&setup=true&lang=js"

import "./Sidenav.vue?vue&type=style&index=0&id=0316ae1c&scoped=true&lang=css"

import exportComponent from "/var/www/html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0316ae1c"]])

export default __exports__